module.exports = __webpack_public_path__ + "img/logistics.ab198b35.jpg";